<script>
export default {
  name: 'ProgressStatus',
  props: {
    total: Number,
    current: Number,
  },
  mounted() { },
  methods: { },
  computed: {
    barWidth() {
      if (this.total > 0) {
        return (this.current - 1) / (this.total - 1) * 100;
      }
      return 0;
    }
  }
};
</script>

<template>
  <div class="progress">
    <div v-if="current <= total" class="progress__label">{{$t('quiz.levelOverview', { a: current, b: total })}}</div>
    <div v-if="current > total" class="progress__label">{{$t('quiz.expertStatus')}}</div>
    <div class="progress__bar" v-bind:style="{width: barWidth + '%'}"></div>
  </div>
</template>

<style lang="scss" scoped>
.progress__label {
  font-size: 1.125em;
  border-bottom: .125rem solid var(--dark);
}
.progress__bar {
  width: 0;
  max-width: 100%;
  height: .625rem;
  background: var(--dark);
  transition: width 200ms;
}
</style>